import apiProvinces from '@/services/api/provinces';

export default {
    namespaced: true,
    state: {
        provinces: []
    },
    getters: {
        getProvinces (state) {
            return state.provinces;
        }
    },
    mutations: {
        setProvinces (state, payload) {
            state.provinces = payload;
        }
    },
    actions: {
        async getProvinces (context) {
            if (context.getters.getProvinces.length <= 0) {
                const { data } = await apiProvinces.getProvinces();
                context.commit('setProvinces', data.data);
            }
        }
    }
};
